import UILockBadge from 'UIComponents/badge/UILockBadge';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';

// Enabled publish button with lock icon as upgrade point modal entry
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LockedPublishButton = ({
  actions,
  children,
  onClick
}) => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      whiteSpace: 'nowrap'
    },
    children: /*#__PURE__*/_jsxs(UIButtonGroup, {
      children: [/*#__PURE__*/_jsxs(UIButton, {
        use: "primary",
        size: "small",
        onClick: onClick,
        children: [children, /*#__PURE__*/_jsx(UILockBadge, {})]
      }), actions && /*#__PURE__*/_jsx(UIDropdown, {
        "data-test-id": "issue-dropdown",
        buttonUse: "primary",
        buttonText: /*#__PURE__*/_jsx(UIIcon, {
          name: "down"
        }),
        buttonClassName: "p-x-1",
        buttonSize: "small",
        caretRenderer: null,
        style: {
          borderLeft: `1px solid rgba(255, 255, 255, 0.4)`
        },
        children: /*#__PURE__*/_jsx(UIList, {
          children: actions.map((action, index) => {
            const {
              label,
              onClick: actionHandler,
              id
            } = action;
            return /*#__PURE__*/_jsx(UIButton, {
              "data-test-id": id,
              onClick: actionHandler,
              children: label
            }, index);
          })
        })
      })]
    })
  });
};
export default LockedPublishButton;